import { render, staticRenderFns } from "./ProgrammaticTargetForm.vue?vue&type=template&id=0d4b3978&scoped=true"
import script from "./ProgrammaticTargetForm.vue?vue&type=script&lang=js"
export * from "./ProgrammaticTargetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b3978",
  null
  
)

export default component.exports